import React from 'react';
import { MoonIcon, SunIcon } from '@heroicons/react/24/outline';
import { useTheme } from '../../context/ThemeContext';

const ThemeToggle: React.FC<{ compact?: boolean }> = ({ compact = false }) => {
  const { theme, setTheme } = useTheme();
  const buttonClasses = 'inline-flex min-h-11 min-w-11 items-center justify-center rounded-md transition-colors motion-reduce:transition-none motion-reduce:duration-0 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 dark:focus-visible:ring-offset-gray-900';

  return (
    <div
      role="group"
      aria-label="Theme"
      className={`inline-flex rounded-lg bg-gray-100 dark:bg-gray-800 ${compact ? 'p-0' : 'p-1'}`}
    >
      <button
        type="button"
        title="Use light theme"
        aria-label="Use light theme"
        aria-pressed={theme === 'light'}
        onClick={() => setTheme('light')}
        className={`${buttonClasses} ${theme === 'light'
          ? 'bg-amber-100 text-amber-700 shadow-sm dark:bg-amber-400/20 dark:text-amber-300'
          : 'text-gray-500 hover:bg-white hover:text-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-gray-200'
        }`}
      >
        <SunIcon aria-hidden="true" className="h-5 w-5" />
      </button>
      <button
        type="button"
        title="Use dark theme"
        aria-label="Use dark theme"
        aria-pressed={theme === 'dark'}
        onClick={() => setTheme('dark')}
        className={`${buttonClasses} ${theme === 'dark'
          ? 'bg-blue-100 text-blue-700 shadow-sm dark:bg-blue-500/20 dark:text-blue-300'
          : 'text-gray-500 hover:bg-white hover:text-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-gray-200'
        }`}
      >
        <MoonIcon aria-hidden="true" className="h-5 w-5" />
      </button>
    </div>
  );
};

export default ThemeToggle;
